import { useContext, useMemo, useCallback } from 'react';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useShiftEndTimeColumn = () => {
  const { t, timeFormat } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => params.data?.scheduleOut ?? null, []);

  const valueFormatter = useCallback((params) => (params.value ? moment(params.value).format(timeFormat) : ''), [
    timeFormat
  ]);

  const comparator = useCallback((valueA, valueB) => {
    if (!valueA && !valueB) return 0;
    if (!valueA) return 1;
    if (!valueB) return -1;
    return moment(valueA).diff(moment(valueB));
  }, []);

  return useMemo(
    () => ({
      field: 'scheduleOut',
      headerName: t('endTimes'),
      width: 115,
      valueGetter,
      valueFormatter,
      comparator
    }),
    [t, valueGetter, valueFormatter, comparator]
  );
};

export default useShiftEndTimeColumn;
